class MakeKey {
  carrier({ siteNo, rtuNo, deviceNo }) {
    const kind = 60; // carrier code
    const deviceGroupNo = 1; // carrier group code
    if (rtuNo.length > 1) {
      rtuNo = rtuNo.substring(rtuNo.length - 1);
    }

    return `n00407-${siteNo}-${String(rtuNo).padStart(2, '0')}${String(kind).padStart(2, '0')}${String(deviceNo).padStart(2, '0')}`;
  }

  battery({ siteNo, rtuNo, deviceNo }) {
    const kind = 70; // battery code
    if (rtuNo.length > 1) {
      rtuNo = rtuNo.substring(rtuNo.length - 1);
    }
    return `n00407-${siteNo}-${String(rtuNo).padStart(2, '0')}${String(kind).padStart(2, '0')}${String(deviceNo).padStart(2, '0')}`;
  }

  meter({ siteNo, rtuNo, deviceNo }) {
    const kind = 71; // meter code 
    if (rtuNo.length > 1) {
      rtuNo = rtuNo.substring(rtuNo.length - 1);
    }
    return `n00407-${siteNo}-${String(rtuNo).padStart(2, '0')}${String(kind).padStart(2, '0')}${String(deviceNo).padStart(2, '0')}`;
  }

  // 전력량계(type별) 시리얼 번호: n00407-{siteNo}-0171{type}01 (type: PV, HS)
  meterByType({ siteNo, type }) {
    return `n00407-${siteNo}-0171${type}01`;
  }

}


export default new MakeKey();
